import { useCallback, useEffect } from 'react';

import type { LeaseActionProps } from '../../../models/Types';
import { LeaseArtifactType } from '@zg-rentals/ts-leasing-client';
import { useResendSigningEmailsMutation } from '../../../utils/queries';
import { logError } from '@zg-rentals/log-error';
import { Toast, useToast } from '@zillow/constellation-10';
import { useLeasingUrlParams } from '../../../hooks';

type Props = LeaseActionProps;

function ResendSigningEmailsLeaseExtension({ lease }: Props) {
  const { renewalId } = useLeasingUrlParams();
  const { enqueueToast } = useToast();
  const latestExtension = lease?.latestExtension ?? null;
  const extensionId = renewalId || latestExtension?.id || '';

  const onEmailSentSuccess = useCallback(() => {
    enqueueToast(<Toast tone="success">Emails for signing successfully resent</Toast>);
  }, [enqueueToast]);

  const onEmailSendError = useCallback(() => {
    enqueueToast(<Toast tone="critical">Emails for signing were not resent, try again later</Toast>);
  }, [enqueueToast]);

  const resendSigningEmailsMutation = useResendSigningEmailsMutation();

  useEffect(() => {
    resendSigningEmailsMutation
      .mutateAsync({
        postData: {
          leaseArtifactId: extensionId as unknown as number,
          leaseArtifactType: LeaseArtifactType.LEASE_EXTENSION_RENEWAL,
        },
      })
      .then(function () {
        onEmailSentSuccess();
        return;
      })
      .catch(function (error) {
        logError({ error, context: 'ResendSigningEmailsLeaseExtension' });
        onEmailSendError();
      });
  }, [extensionId, onEmailSentSuccess, onEmailSendError]);

  return null;
}

export default ResendSigningEmailsLeaseExtension;
